import { render, staticRenderFns } from "./Creditor.vue?vue&type=template&id=3979ae17&scoped=true&"
import script from "./Creditor.vue?vue&type=script&lang=ts&"
export * from "./Creditor.vue?vue&type=script&lang=ts&"
import style0 from "./Creditor.vue?vue&type=style&index=0&id=3979ae17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979ae17",
  null
  
)

export default component.exports